import { Add, Star } from '@mui/icons-material';
import React, { FC, useContext } from 'react';
import { tiles } from '../../assets/tiles';
import * as S from './styles';
import { ThemeContext } from 'styled-components';
import { ThemeEnum } from '../../handlers/ThemeHandler';
import ThemedTooltip from '../Tooltip/Tooltip';
import { TooltipBody } from './TooltipBody';
import { TranslationContext } from '../../handlers/TranslationsHandler';

interface ITileOverview {
  name: string;
  title: string;
  description: string;
  onAdd: () => void;
  selected?: boolean;
  isPremiumOnly: boolean;
  theme?: string;
}

export const TileOverview: FC<ITileOverview> = ({
  name,
  title,
  description,
  selected,
  onAdd,
  isPremiumOnly
}) => {
  const theme =
    ThemeEnum[(useContext(ThemeContext) as any).theme || ThemeEnum.light];
  const { language } = useContext(TranslationContext);

  return (
    <ThemedTooltip
      placement="right-start"
      title={<TooltipBody />}
      disableHoverListener={!isPremiumOnly}
    >
      <S.TileOverview
        onClick={() => {
          if (!isPremiumOnly) {
            onAdd();
          }
        }}
        isPremiumOnly={isPremiumOnly}
        isSelected={!!selected}
      >
        <S.Image src={tiles[theme][language][name]} />
        <S.Content>
          <S.Name>{title || name}</S.Name>
          <S.Description>{description}</S.Description>
        </S.Content>
        <S.AddContainer>{isPremiumOnly ? <Star /> : <Add />}</S.AddContainer>
      </S.TileOverview>
    </ThemedTooltip>
  );
};
